import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { go } from '@api3/commons';
import { toasts } from '../../components/notifications';
import { useConnectedAccount } from './use-connected-account';
import { useDisconnect } from './use-disconnect';

interface ChainAlysisResponse {
  identifications: any[];
}

// Check if connected account is on sanctions lists. We are using Chainalysis API (https://public.chainalysis.com/docs/index.html)
// to check if the address is sanctioned. Because of their CORS policy, we are proxying the request through Cloudflare Worker.
export const useCheckSanctionedAddress = () => {
  const { connectedAddress } = useConnectedAccount();
  const disconnect = useDisconnect();

  useEffect(() => {
    const checkIfAddressIsSanctioned = async (address: string) => {
      // Parsed inside "go": the proxy responds with 200 and no identifications while Chainalysis is failing
      const result = await go(async () => {
        const response = await fetch(`https://sanctioned-addresses-api.api3dao.workers.dev/?address=${address}`);
        const { identifications }: ChainAlysisResponse = await response.json();
        return identifications.length > 0;
      });

      if (result.error) {
        Sentry.captureException(new Error(`Error checking if address is sanctioned: ${result.error}`));
        return;
      }

      if (result.data) {
        toasts.error({
          message: 'API3 is unable to serve this address.',
        });
        disconnect();
      }
    };

    if (connectedAddress) {
      checkIfAddressIsSanctioned(connectedAddress);
    }
  }, [connectedAddress]);
};
